module.exports = __webpack_public_path__ + "static/media/profileTitle.1a56888b.png";